import { render, staticRenderFns } from "./StudentsIndex.vue?vue&type=template&id=a90a85c4"
import script from "./StudentsIndex.vue?vue&type=script&lang=js"
export * from "./StudentsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports